import { combineReducers, Reducer } from 'redux';
import { getType } from '@anm/helpers/saga/typesafe-actions';

import { templateActions } from '../template';
import { selectPreviewFromList } from '../template/selectors';

import {
  CategoryActions,
  CATEGORY_LIST_ERROR,
  CATEGORY_LIST_REQUEST,
  CATEGORY_LIST_SUCCESS,
  RESET_CURRENT_CATEGORY,
  UPDATE_CURRENT_CATEGORY
} from './actions';
import { CategoryListState, CurrentCategoryState } from './types';

const initialCategoryState: CategoryListState = {
  list: [],
  count: 0,
  limit: 150,
  offset: 0,
  isError: false,
  isPending: false
};

const categoryListReducer: Reducer<CategoryListState, CategoryActions> = (
  state = initialCategoryState,
  action
) => {
  switch (action.type) {
    case CATEGORY_LIST_REQUEST: {
      return {
        ...state,
        isError: false,
        isPending: true
      };
    }
    case CATEGORY_LIST_SUCCESS: {
      const { list, count } = action.payload;
      return {
        ...state,
        list,
        count,
        isPending: false
      };
    }
    case CATEGORY_LIST_ERROR: {
      const { payload: newError } = action;
      return {
        ...state,
        isError: true,
        error: newError,
        isPending: false
      };
    }
    default:
      return state;
  }
};

const initialCurrentCategoryState: CurrentCategoryState = {
  name: '',
  path: '',
  description: ''
};
const currentCategoryReducer: Reducer<CurrentCategoryState, CategoryActions> = (
  state = initialCurrentCategoryState,
  action
) => {
  switch (action.type) {
    case getType(templateActions.fetchTemplateListAsync.success): {
      const { content: categoryList } = action.payload;
      return {
        ...state,
        preview: selectPreviewFromList(categoryList)
      };
    }
    case RESET_CURRENT_CATEGORY: {
      return initialCurrentCategoryState;
    }
    case UPDATE_CURRENT_CATEGORY: {
      const { currentCategory: newCurrent } = action.payload;
      return { ...state, ...newCurrent };
    }

    default:
      return state;
  }
};

const categoryReducer = combineReducers({
  items: categoryListReducer,
  current: currentCategoryReducer
});

export default categoryReducer;
